import { useQuery } from '@tanstack/react-query';
import { fetchGraphSplits, fetchGraphSplitsByCategory } from '../services/graphApi';

export function useGraphSplitsQuery(
  eventId: number | null,
  categoryId?: number | null,
  categoryName?: string
) {
  return useQuery({
    queryKey: ['graph-splits', eventId, categoryId],
    queryFn: () => categoryId == null
      ? fetchGraphSplits(eventId ?? 0)
      : fetchGraphSplitsByCategory(eventId ?? 0, categoryId, categoryName),
    enabled: eventId != null,
  });
}
